import { Navigate, Outlet } from "react-router-dom";
import jwtDecode from "jwt-decode";

const PrivateRoute = () => {
  const token = sessionStorage.getItem("token");
  const { isOrg } = token ? jwtDecode(token) : { isOrg: false };

  return token ? (
    isOrg ? (
      <Navigate replace={true} to={"/org/profile"} />
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
